export default __webpack_public_path__ + "asset/img/shop-logo/1~17400c8f.png";